import clsx from 'clsx';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import NonRichtextStringInput from '../../../../../../../../Resource/FormTemplates/Inputs/NonRichtextStringInput';
import WithField from '../../../../../../../../Resource/FormTemplates/Inputs/WithField';
import { T } from '../../../../../../../../Translations';
import LaunchIcon from '../../../../../../../Cutesies/LaunchIcon';
import ModalStore from '../../../../../../../Modal/Store';
import PreviewStore from '../../Store';

interface Props {
  store: PreviewStore;
  learningCollectionDescriptionModalStore: ModalStore;
}

function Inputs({ store, learningCollectionDescriptionModalStore }: Props) {
  return store.learningCollectionStore.template
    .map((template) => (
      <>
        <div className="border-b px-7 py-7">
          <WithField kind="string" name="name" fields={template.fields}>
            {(field) => <NonRichtextStringInput field={field} disabled={false} />}
          </WithField>
        </div>
        <div className="border-b px-7 py-7">
          <p className="mb-2 text-sm font-semibold">
            <T kind="Description" />
          </p>
          <button
            className={clsx(
              'flex w-full rounded border border-teal-600 py-2.5',
              'items-center justify-center text-sm font-semibold text-teal-600',
            )}
            onClick={learningCollectionDescriptionModalStore.open}
          >
            <LaunchIcon />
            <span className="ml-2.5">
              <T kind="Launch Content Editor" />
            </span>
          </button>
        </div>
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Inputs);
